
import { Box } from "@mui/material";

export const StudentChip = ({ name }) => {
  const initials = name
    .split(" ")
    .map(word => word[0])
    .join("")
    .slice(0, 2)
    .toUpperCase();

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: "8px",
        padding: "6px 10px",
        borderRadius: "999px",
        border: "1px solid #ddd",
        backgroundColor: "#fff",
        fontSize: "14px",
        fontWeight: 500
      }}
    >
      {/* Avatar */}
      <Box
        sx={{
          width: "24px",
          height: "24px",
          borderRadius: "50%",
          backgroundColor: "#E6D9FF",
          color: "#5A2DCC",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          fontSize: "12px",
          fontWeight: 600
        }}
      >
        {initials}
      </Box>

      {/* Name */}
      <span>{name}</span>
    </Box>
  );
};
